// extracted by mini-css-extract-plugin
module.exports = {"banner":"_afce517","close":"_b6ff6dd","disabled":"_dd0e7c6","image":"_8a9d14d","disclaimer":"_3e61515","shareApple":"_48f5721"};